export default {
  setHeader() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer your_token_here",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
      "Access-Control-Allow-Headers": "Authorization, Content-Type",
    };
    return headers;
  },
};
